export const HOW_TO = [
  {
    title: 'Choose a competition',
    body: 'Browse the Live and Upcoming competitions below. Each card shows the prize pool, the DEX pool, how the score works and whether the pool’s liquidity is verified as locked.',
  },
  {
    title: 'Trade in the pool',
    body: 'Trade the project token in the competition’s pool while it is live. Trade volume competitions count your buys and sells; Buy & hold competitions score the tokens you buy and keep until the end.',
  },
  {
    title: 'Watch the leaderboard',
    body: 'The leaderboard refreshes while the competition runs. When it ends the validators sign the final result, and you can check its hash against the contract.',
  },
  {
    title: 'Claim your reward',
    body: 'Winners claim their share with one wallet transaction on BNB Smart Chain. If no result is published within 3 days of the end, the whole prize can be returned to the creator.',
  },
]

export const FAQ = [
  {
    q: 'Why was my traded volume not tracked?',
    a: 'Only swaps in the competition’s own pool between its start and end count. Trades in another pool or on another DEX, or outside that window, are ignored. The leaderboard is provisional until the result is signed and refreshes every few minutes.',
  },
  {
    q: 'How is the prize split?',
    a: 'The top winners share the prize pro rata to their score. The exact amounts are fixed in the signed result and the contract pays exactly those amounts, nothing else.',
  },
  {
    q: 'Who decides the result?',
    a: 'The contract’s validator set signs the result. The contract checks the signature and stores the result hash; the full report is public and each competition page shows whether it matches the hash on-chain.',
  },
  {
    q: 'What if no result is published?',
    a: 'Three days after the end, anyone can return the full prize to the creator. Prizes are never held longer than that.',
  },
  {
    q: 'What does “LP locked” mean?',
    a: 'We read CADINU’s lock contracts on-chain. When at least half of the pool’s liquidity is locked there, the competition shows a verified tick with the date it stays locked until. It checks the lock only, it is not an audit of the project, and locks made elsewhere are not detected.',
  },
  {
    q: 'Which tokens can be the prize?',
    a: 'Any BEP-20 token, except tokens that take a fee on transfer (the contract rejects them). Tokens the contract owner has not listed are marked as unverified.',
  },
]
